
import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const TRANSLATIONS_VERSION = 4;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",

    supportedLngs: ["lt", "en", "ru", "fin"],

    debug: false,

    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${TRANSLATIONS_VERSION}`,
    },

    detection: {
      order: ["localStorage", "cookie"],

      lookupLocalStorage: "lang",
      lookupCookie: "lang",

      caches: ["localStorage", "cookie"],

      excludeCacheFor: ["cimode"],

      cookieOptions: {
        path: "/",
        sameSite: "lax",
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
